module.exports = __webpack_public_path__ + "static/media/IndustryLeader002.819345d3.png";